import helpers from '../helpers';

function sizes() {
	const bottomContent = $('.intro__content').innerHeight() + $('.intro__content').offset().top;

	if ($('.intro__items').offset().top < bottomContent) {
		const h = bottomContent - $('.intro__items').offset().top;

		gsap.set('.intro', {
			height: `+=${h}`,
		});
	}
}

function init() {
	sizes();

	helpers.$body.on('click.intro', '.js-intro-link', (e) => {
		e.preventDefault();
		const id = $(e.currentTarget).attr('href');

		helpers.scrollTo($(id));
	});

	helpers.$window.on('resize.intro', () => {
		$('.intro').removeAttr('style');

		sizes();
	});
}

function destroy() {
	helpers.$body.off('.intro');
	helpers.$window.off('.intro');
}

export default {
	init,
	destroy,
};
